import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../../services";
import { decryptMessage } from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";

export const getBillData = createAsyncThunk(
  "Bills/get bills data",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getApprovedPendingBills = createAsyncThunk(
  "Bills/get bills overview",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
//--------for expense report(overall+Billwise)----------
export const getOverallExpenses = createAsyncThunk(
  "ManageBills/expense-report",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesInventory = createAsyncThunk(
  "ManageBills/expense-report-by-inventory",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesSubContractor = createAsyncThunk(
  "ManageBills/expense-report-by-subContractor",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesMachineRental = createAsyncThunk(
  "ManageBills/expense-report-by-machineRental",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesMachineryRepair = createAsyncThunk(
  "ManageBills/expense-report-by-machineryRepair",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesMiscellaneous = createAsyncThunk(
  "ManageBills/expense-report-by-miscellaneous",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
//-------------expenses by billtype and date for billreport---------------------------------
export const getOverallExpensesBillReport = createAsyncThunk(
  "ManageBills/expense-billreport",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesInventoryBillReport = createAsyncThunk(
  "ManageBills/expense-billreport-by-inventory",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesSubContractorBillReport = createAsyncThunk(
  "ManageBills/expense-billreport-by-subContractor",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesMachineRentalBillReport = createAsyncThunk(
  "ManageBills/expense-billreport-by-machineRental",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesMachineryRepairBillReport = createAsyncThunk(
  "ManageBills/expense-billreport-by-machineryRepair",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesMiscellaneousBillReport = createAsyncThunk(
  "ManageBills/expense-billreport-by-miscellaneous",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
//------overall expense by projectwise------
export const getOverallExpensesByProjectTypeForTable = createAsyncThunk(
  "ManageBills/expense-report-by-projectTable",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOverallExpensesByProjectTypeForGraph = createAsyncThunk(
  "ManageBills/expense-report-by-projectGraph",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
//--------------------expenses for selected project in billtype wise for table------------------
export const getExpensesForProjectInventory = createAsyncThunk(
  "ManageBills/expense-report-by-type-and-project-inventory",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectSubContractor = createAsyncThunk(
  "ManageBills/expense-report-by-type-and-project-subContractor",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectMachineRental = createAsyncThunk(
  "ManageBills/expense-report-by-type-and-project-machieRental",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectMachineryRepair = createAsyncThunk(
  "ManageBills/expense-report-by-type-and-project-machineryRepair",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectMiscellaneous = createAsyncThunk(
  "ManageBills/expense-report-by-type-and-project-miscellaneous",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
//--------------------expenses for selected project in billtype wise for Graph------------------
export const getExpensesForProjectInventoryGraph = createAsyncThunk(
  "ManageBills/expense-graph-by-type-and-project-inventory",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectSubContractorGraph = createAsyncThunk(
  "ManageBills/expense-graph-by-type-and-project-subContractor",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectMachineRentalGraph = createAsyncThunk(
  "ManageBills/expense-graph-by-type-and-project-machieRental",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectMachineryRepairGraph = createAsyncThunk(
  "ManageBills/expense-graph-by-type-and-project-machineryRepair",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getExpensesForProjectMiscellaneousGraph = createAsyncThunk(
  "ManageBills/expense-graph-by-type-and-project-miscellaneous",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
type SliceState = {
  loading: boolean;
  billsData: object | string | boolean | null;
  pendingAndApprovedBills: object | string | boolean | null;
  overallExpenses: null | Object | "";
  overallExpensesInventory: null | Object | "";
  overallExpensesSubContractor: null | Object | "";
  overallExpensesMachineRental: null | Object | "";
  overallExpensesMachineryRepair: null | Object | "";
  overallExpensesMiscellaneous: null | Object | "";
  //------------overall expense for bill report----------------
  overallExpensesBillReport: null | Object | "";
  overallExpensesInventoryBillReport: null | Object | "";
  overallExpensesSubContractorBillReport: null | Object | "";
  overallExpensesMachineRentalBillReport: null | Object | "";
  overallExpensesMachineryRepairBillReport: null | Object | "";
  overallExpensesMiscellaneousBillReport: null | Object | "";
  //------------for two different project scenario-----------
  overallExpensesByProjectTypeForTable: null | Object | "";
  overallExpensesByProjectTypeForGraph: null | Object | "";
  //--------project and billtypewise(table)-----------------------
  expensesForProjectInventory: null | Object | "";
  expensesForProjectSubContractor: null | Object | "";
  expensesForProjectMachineRental: null | Object | "";
  expensesForProjectMachineryRepair: null | Object | "";
  expensesForProjectMiscellaneous: null | Object | "";
   //--------project and billtypewise(Graph)-----------------------
   expensesForProjectInventoryGraph: null | Object | "";
   expensesForProjectSubContractorGraph: null | Object | "";
   expensesForProjectMachineRentalGraph: null | Object | "";
   expensesForProjectMachineryRepairGraph: null | Object | "";
   expensesForProjectMiscellaneousGraph: null | Object | "";
};

const initialState: SliceState = {
  loading: false,
  billsData: [],
  pendingAndApprovedBills: {
    approved: 0,
    pending: 0,
  },
  overallExpenses: "",
  overallExpensesInventory: "",
  overallExpensesSubContractor: "",
  overallExpensesMachineRental: "",
  overallExpensesMachineryRepair: "",
  overallExpensesMiscellaneous: "",
    //------------overall expense for bill report----------------
    overallExpensesBillReport: "",
    overallExpensesInventoryBillReport: "",
    overallExpensesSubContractorBillReport:"",
    overallExpensesMachineRentalBillReport: "",
    overallExpensesMachineryRepairBillReport:"",
    overallExpensesMiscellaneousBillReport: "",
   //------------for two different project scenario-----------
  overallExpensesByProjectTypeForTable: "",
  overallExpensesByProjectTypeForGraph: "",
  //--------project and billtypewise(table)-----------------------
  expensesForProjectInventory: "",
  expensesForProjectSubContractor:  "",
  expensesForProjectMachineRental: "",
  expensesForProjectMachineryRepair: "",
  expensesForProjectMiscellaneous: "",
  //--------project and billtypewise(Graph)-----------------------
  expensesForProjectInventoryGraph: "",
  expensesForProjectSubContractorGraph: "",
  expensesForProjectMachineRentalGraph: "",
  expensesForProjectMachineryRepairGraph: "",
  expensesForProjectMiscellaneousGraph: "",
};

const BillSlice = createSlice({
  name: "image",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getBillData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBillData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.billsData = data?.data;
      } else {
        // toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getBillData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getApprovedPendingBills.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getApprovedPendingBills.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.pendingAndApprovedBills = data?.data;
      } else {
        // toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getApprovedPendingBills.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //------for expense report----
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpenses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpenses.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpenses = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpenses.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesInventory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesInventory.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesInventory = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesInventory.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesSubContractor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesSubContractor.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesSubContractor = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesSubContractor.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesMachineRental.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesMachineRental.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesMachineRental = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesMachineRental.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesMachineryRepair.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesMachineryRepair.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesMachineryRepair = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesMachineryRepair.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesMiscellaneous.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesMiscellaneous.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesMiscellaneous = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesMiscellaneous.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //-------------Expense by billtype and date for billreport-----------------------
    builder.addCase(getOverallExpensesBillReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesBillReport.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesBillReport = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesBillReport.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesInventoryBillReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesInventoryBillReport.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesInventoryBillReport = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesInventoryBillReport.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesSubContractorBillReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesSubContractorBillReport.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesSubContractorBillReport = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesSubContractorBillReport.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesMachineRentalBillReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesMachineRentalBillReport.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesMachineRentalBillReport = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesMachineRentalBillReport.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesMachineryRepairBillReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesMachineryRepairBillReport.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesMachineryRepairBillReport = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesMachineryRepairBillReport.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getOverallExpensesMiscellaneousBillReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesMiscellaneousBillReport.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesMiscellaneousBillReport = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesMiscellaneousBillReport.rejected, (state) => {
      state.loading = true;
    });

    //-----overall Expenses projectwise for two different scenario--------------------

     //TODO: Get API CALL START ---- 
     builder.addCase(getOverallExpensesByProjectTypeForTable.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesByProjectTypeForTable.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesByProjectTypeForTable = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesByProjectTypeForTable.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

     //TODO: Get API CALL START ---- 
     builder.addCase(getOverallExpensesByProjectTypeForGraph.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallExpensesByProjectTypeForGraph.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallExpensesByProjectTypeForGraph = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getOverallExpensesByProjectTypeForGraph.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
//-----------------------------project and bill for table----------------------------
     //TODO: Get API CALL START ---- 
     builder.addCase(getExpensesForProjectInventory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExpensesForProjectInventory.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.expensesForProjectInventory = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getExpensesForProjectInventory.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getExpensesForProjectSubContractor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExpensesForProjectSubContractor.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.expensesForProjectSubContractor = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getExpensesForProjectSubContractor.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getExpensesForProjectMachineRental.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExpensesForProjectMachineRental.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.expensesForProjectMachineRental = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getExpensesForProjectMachineRental.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
//TODO: Get API CALL START ---- 
builder.addCase(getExpensesForProjectMachineryRepair.pending, (state) => {
  state.loading = true;
});
builder.addCase(getExpensesForProjectMachineryRepair.fulfilled, (state, action) => {
  state.loading = false;
  const data: any =
    process.env.NODE_ENV === "development"
      ? action.payload?.data
      : decryptMessage(JSON.stringify(action.payload?.data));
  if (data?.status) {
    state.expensesForProjectMachineryRepair = data?.data;
  } else {
    toaster("error", data?.message);
    console.log(data?.status);
  }
});
builder.addCase(getExpensesForProjectMachineryRepair.rejected, (state) => {
  state.loading = true;
});
//TODO: Get API CALL END
//TODO: Get API CALL START ---- 
builder.addCase(getExpensesForProjectMiscellaneous.pending, (state) => {
  state.loading = true;
});
builder.addCase(getExpensesForProjectMiscellaneous.fulfilled, (state, action) => {
  state.loading = false;
  const data: any =
    process.env.NODE_ENV === "development"
      ? action.payload?.data
      : decryptMessage(JSON.stringify(action.payload?.data));
  if (data?.status) {
    state.expensesForProjectMiscellaneous = data?.data;
  } else {
    toaster("error", data?.message);
    console.log(data?.status);
  }
});
builder.addCase(getExpensesForProjectMiscellaneous.rejected, (state) => {
  state.loading = true;
});
//TODO: Get API CALL END
//-----------------------------project and bill for table----------------------------
     //TODO: Get API CALL START ---- 
     builder.addCase(getExpensesForProjectInventoryGraph.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExpensesForProjectInventoryGraph.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.expensesForProjectInventoryGraph = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getExpensesForProjectInventoryGraph.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getExpensesForProjectSubContractorGraph.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExpensesForProjectSubContractorGraph.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.expensesForProjectSubContractorGraph = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getExpensesForProjectSubContractorGraph.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START ---- 
    builder.addCase(getExpensesForProjectMachineRentalGraph.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExpensesForProjectMachineRentalGraph.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.expensesForProjectMachineRentalGraph = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(getExpensesForProjectMachineRentalGraph.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
//TODO: Get API CALL START ---- 
builder.addCase(getExpensesForProjectMachineryRepairGraph.pending, (state) => {
  state.loading = true;
});
builder.addCase(getExpensesForProjectMachineryRepairGraph.fulfilled, (state, action) => {
  state.loading = false;
  const data: any =
    process.env.NODE_ENV === "development"
      ? action.payload?.data
      : decryptMessage(JSON.stringify(action.payload?.data));
  if (data?.status) {
    state.expensesForProjectMachineryRepairGraph = data?.data;
  } else {
    toaster("error", data?.message);
    console.log(data?.status);
  }
});
builder.addCase(getExpensesForProjectMachineryRepairGraph.rejected, (state) => {
  state.loading = true;
});
//TODO: Get API CALL END
//TODO: Get API CALL START ---- 
builder.addCase(getExpensesForProjectMiscellaneousGraph.pending, (state) => {
  state.loading = true;
});
builder.addCase(getExpensesForProjectMiscellaneousGraph.fulfilled, (state, action) => {
  state.loading = false;
  const data: any =
    process.env.NODE_ENV === "development"
      ? action.payload?.data
      : decryptMessage(JSON.stringify(action.payload?.data));
  if (data?.status) {
    state.expensesForProjectMiscellaneousGraph = data?.data;
  } else {
    toaster("error", data?.message);
    console.log(data?.status);
  }
});
builder.addCase(getExpensesForProjectMiscellaneousGraph.rejected, (state) => {
  state.loading = true;
});
//TODO: Get API CALL END
  },
});

export const ImageActions = BillSlice.actions;

export default BillSlice;
